import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import * as styles from "./LoadingDots.css";

export interface LoadingDotsProps {
  theme?: "light" | "dark";
}

export default function LoadingDots({ theme = "dark" }: LoadingDotsProps) {
  useGSAP(() => {
    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 0,
      defaults: { duration: 0.2, delay: 0.1 },
    });

    tl.to("#dot-1", { opacity: "0.5", scale: 0.7 });

    tl.to("#dot-2", { opacity: "1", scale: 1 }, "<");
    tl.to("#dot-2", { opacity: "0.5", scale: 0.7 });

    tl.to("#dot-3", { opacity: "1", scale: 1 }, "<");
    tl.to("#dot-3", { opacity: "0.5", scale: 0.7 });

    tl.to("#dot-1", { opacity: "1", scale: 1 }, "<");
  });
  return (
    <div className={styles.loading}>
      <div className={styles.dotContainer}>
        <div
          className={styles.dot({ active: true, theme: theme })}
          id="dot-1"
        />
      </div>
      <div className={styles.dotContainer}>
        <div
          className={styles.dot({ active: false, theme: theme })}
          id="dot-2"
        />
      </div>
      <div className={styles.dotContainer}>
        <div
          className={styles.dot({ active: false, theme: theme })}
          id="dot-3"
        />
      </div>
    </div>
  );
}
